import { isArray } from '@utils/guards';

import type { IApiErrors, IApiFormErrors } from '../services/query/types';

export default function prepareApiFormErrors(errors: IApiErrors): IApiFormErrors {
  const result: IApiFormErrors = {};

  for (const [key, value] of Object.entries(errors)) {
    if (isArray(value)) {
      result[key] = [...value];
    } else if (value?.attribute) {
      result[key] = [...value.attribute];
    }
  }

  return result;
}
